import React from 'react'
import { Button } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { CheckOutlined } from '@ant-design/icons'
import styles from './IntegrationSettingsFooter.module.scss'

const IntegrationSettingsFooter: React.FC<{ handleDeleteClick: () => void }> = (props) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { id: integrationId } = router.query

  return <div className={styles.content}>
    <Button
      danger
      size='large'
      className={styles.deleteButton}
      onClick={props.handleDeleteClick}
    >
      {t('developers.DeleteIntegration')}
    </Button>

    <Button
      size='large'
      type='primary'
      icon={<CheckOutlined />}
      className={styles.doneButton}
      onClick={() => router.push(`/developers/integration-details?id=${integrationId}`)}
    >
      {t('general.Done')}
    </Button>
  </div>
}

export default IntegrationSettingsFooter
